import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { CacheKey } from '../shared/constants/cachekey.constants';
import { SharedConstants } from '../shared/constants/shared.constants';
export class SSO {
    public static SSO_Login_URL = environment.ssoApiURL + '/auth';
    public static SSO_Client_ID = environment.ssoClientID;
    public static SSO_Login_Redirect_URL = window.location.origin + '/login';
    // public static SSO_Login_Redirect_URL = window.location.origin + '/' + SSO.getISOThreeLetterCountryCode(SSO.countryName) + '/login';
    public static SSO_Login_Response_Type = 'code';
    public static SSO_Login_Nonce = 'FLPITITAN';
    public static SSO_Logout_URL = environment.ssoApiURL + '/logout';

    public static ACCESS_TOKEN = environment.removeObsoleteCookies === true ? "appcoporate." + environment.accessToken : environment.accessToken;
    public static REFRESH_TOKEN = environment.removeObsoleteCookies === true ? "appcoporate." + environment.refreshToken : environment.refreshToken;
    public static NONCE = environment.idNonce;
    public static MEMBER_ID = environment.memberId;
    public static cookieService: CookieService = new CookieService(document);
    public static SSO_Account_URL = environment.accountSiteURL;
    public static ENCRYPTION_KEY = 'j1wootxJBEgAUJHyQ2XDbQ==';
    public static MEMBER_SESSION_STATE = 'EPSS';
    public static MEMBER_SESSIONID = CacheKey.MemberSessionGuid + '_' + environment.envName;
    public static IS_NEW_TOKEN = "appcoporate.isNewToken";
    public static LOCAL_MEMBER_SESSION_ID = "appcoporate.memberSessionId";

    public static getSSOLoginUrl(langCode: string, cartSessionGuid: string, redirectToFavourites?: boolean, accountSiteURL?: string): string {
        if (cartSessionGuid) {
            this.cookieService.set(CacheKey.CartSessionGuid, cartSessionGuid, null, environment.cookiePath, environment.cookieDomain);
        }
        const state = this.getnonce();
        const id_nonce = this.getnonce();
        this.cookieService.set(SSO.NONCE, id_nonce, null, environment.cookiePath, environment.cookieDomain);
        localStorage.setItem('appcoporate.state', JSON.stringify(state));
        if (!window.location.pathname.startsWith('/login')) {
            if (!window.location.pathname.toLowerCase().includes(SharedConstants.LegacyUrlWhitelistPhrase)) {
                localStorage.setItem('appcoporate.Nav_path',
                    JSON.stringify(window.location.pathname + window.location.search));
            }
        } else {
            localStorage.removeItem('appcoporate.Nav_path');
        }
        const isoCountryCode = this.cookieService.get(CacheKey.countryCode);
        if (redirectToFavourites) {
            localStorage.setItem('appcoporate.Nav_path',
                JSON.stringify(environment.shopURL + '/' + isoCountryCode.toLowerCase() + '/' + langCode.toLowerCase() + '/favorite'));
        }
        this.SSO_Login_Redirect_URL = accountSiteURL && !redirectToFavourites ? accountSiteURL + '/login' : this.SSO_Login_Redirect_URL;
        return environment.ssoApiURL + '/auth?client_id=' + this.SSO_Client_ID + '&redirect_uri=' + this.SSO_Login_Redirect_URL +
            '&scope=openid&response_type=code&state=' + state + '&nonce=' + id_nonce;
    }

    public static getSSOLogoutUrl(redirectUri?: string): string {
        return this.SSO_Logout_URL + '?client_id=' + this.SSO_Client_ID + '&redirect_uri=' + (redirectUri || window.location.href);
    }

    public static getCheckLoginFlags() {
        return '&chc=true' + '&actual_url=' + window.location.pathname.split('home')[0] + 'products';
    }

    public static getnonce(): string {
        let d = new Date().getTime();

        if (window.performance && typeof window.performance.now === 'function') {
            d += performance.now();
        }

        const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

        return uuid;
    }

    public static isRemoveObsoleteCookie(): boolean {
        return environment.removeObsoleteCookies;
    }

}
